<template>
  <tk-button
    v-bind="$attrs"
    :disabled="disabled"
    class="tkFavoriteButton"
    :class="{ '-registered': isRegistered, '-disabled': disabled }"
    v-on="$listeners"
  >
    <div
      v-if="message"
      class="tkFavoriteButton_messageArea"
    >
      {{ message }}
    </div>
    <div class="tkFavoriteButton_iconArea">
      <template v-if="!isRegistered">
        <tk-icon
          class="tkFavoriteButton_icon"
          name="heart"
        />
      </template>
      <template v-else>
        <tk-icon
          class="tkFavoriteButton_icon"
          name="heart_on"
        />
      </template>
    </div>
  </tk-button>
</template>

<script>
import TkButton from '../../../atoms/TkButton/TkButton'
import TkIcon from '../../../atoms/TkIcon/TkIcon'

export default {
  name: 'TkFavoriteButton',
  components: {
    TkButton,
    TkIcon,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    isRegistered: {
      type: Boolean,
      default: false,
    },
    notRegisteredMessage: {
      type: String,
      default: '',
    },
    registeredMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    message() {
      return this.isRegistered ? this.registeredMessage : this.notRegisteredMessage
    },
  },
}
</script>

<style lang="scss">
.tkFavoriteButton {
  display: flex !important;
  position: relative !important;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  height: 100% !important;
  width: inherit;
  min-height: 38px !important;
  min-width: 50px;
  color: #F9423A;
  border: 1px solid #F9423A !important;
  background-color: #ffffff;

  &.-registered {
    color: #63666a;
    border-color: #d2d2d2 !important;
  }

  &.-disabled {
    pointer-events: none;
    color: #63666a;
    border-color: #d2d2d2 !important;
    background-color: #d2d2d2;
  }
}

.tkFavoriteButton_messageArea {
  font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", メイリオ, Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", Osaka, sans-serif;
  font-size: 14px;
  font-weight: bold;
  margin: 0 40px;
  white-space: nowrap;
}

.tkFavoriteButton_iconArea {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.tkFavoriteButton_icon {
  height: 24px;
  width: 30px;
}
</style>
